import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-hokhy0-0"
})(["margin:12px auto;"]);
export var InvestorProfile = styled.div.withConfig({
  displayName: "partials__InvestorProfile",
  componentId: "sc-hokhy0-1"
})(["color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.descriptionListTermsTextColor;
});